import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';
import BGVideo from '../layout/BGVideo';

class ScrollItem__TitleType6 extends VScroll_Item {
  timeline;
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.title = GetBy.class("body", this.item)[0];
    this.media1 = GetBy.selector("figure", this.item)[0];
    this.media2 = GetBy.selector("figure", this.item)[1];
    this.media3 = GetBy.selector("figure", this.item)[2];
    this.media4 = GetBy.selector("figure", this.item)[3];
    this.videos = [...GetBy.selector("video", this.item)];

    this.onMove = () => {
      this.updateTitle();
    }

    this.onShow = () => {
      this.videos.map(video => { 
        video.src = video.dataset.src;  // asignamos src aquí
        video.play();
      });
    }

    this.onHide = () => {
      this.videos.map(video => { 
        video.pause();
        video.src = '';
        video.load();
      });
    }
  }

  updateTitle() {
    if(this.progress < .5) {
      this.title.style.opacity = Maths.normalize(0.3, 0.2, this.progress);
      this.media1.style.opacity = Maths.normalize(0.35, 0.25, this.progress);
      this.media4.style.opacity = Maths.normalize(0.40, 0.25, this.progress);
      
      this.media2.style.opacity = Maths.normalize(0.4, 0.3, this.progress);
      this.media3.style.opacity = Maths.normalize(0.45, 0.3, this.progress);
     
    } else {
      this.title.style.opacity = Maths.normalize(0.6, 0.8, this.progress);
      this.media1.style.opacity = Maths.normalize(0.6, 0.7, this.progress);
      this.media2.style.opacity = Maths.normalize(0.65, 0.75, this.progress);
      this.media3.style.opacity = Maths.normalize(0.7, 0.8, this.progress);
      this.media4.style.opacity = Maths.normalize(0.75, 0.85, this.progress);
    }
  }
}

Scroll._registerClass('title--type_6', ScrollItem__TitleType6);